import { FC } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export const Header: FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold text-primary flex items-center gap-2">
          <ShoppingBag className="w-8 h-8" />
          jual.in
        </Link>
      </div>
    </header>
  );
};